/* Mark the destination page separately from hover and expanded menu states. */
(function(){
 function markCurrentPage(){
  const header=document.querySelector('.ag-global-header');
  if(!header)return;
  const preview=document.querySelector('meta[name="ag-preview-page-url"]');
  const current=new URL(preview?.content||location.href,location.href);
  const path=value=>value.replace(/\/$/,'')||'/';
  header.querySelectorAll('.ag-nav-panel a[href],.mobile-menu-links a[href]').forEach(a=>{
   const destination=new URL(a.href,location.href);
   const same=destination.origin===current.origin&&path(destination.pathname)===path(current.pathname)&&!destination.hash&&(path(current.pathname)!=='/search'||destination.searchParams.get('view')===current.searchParams.get('view'));
   if(same)a.setAttribute('aria-current','page');
   else if(a.getAttribute('aria-current')==='page')a.removeAttribute('aria-current');
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',markCurrentPage,{once:true});
 else markCurrentPage();
 document.addEventListener('shopify:section:load',markCurrentPage);
})();
